import { Search } from "lucide-react";
import { useFinanceAccountSearchWorkspace } from "./useFinanceAccountSearchWorkspace";

export function FinanceAccountSearch({ onSelect }: { onSelect: (code: string) => void }) {
  const { term, rows, loading, error, searched, search, changeTerm, select } = useFinanceAccountSearchWorkspace(onSelect);
  return <section aria-label="Mikro cari araması">
    <form className="finance-toolbar" onSubmit={(event) => { event.preventDefault(); void search(); }}>
      <label className="finance-search"><span className="finance-sr-only">Mikro cari kodu veya unvanı</span><Search size={17} />
        <input type="search" value={term} maxLength={80} placeholder="Mikro cari kodu veya unvanı" disabled={loading} onChange={(event) => changeTerm(event.target.value)} /></label>
      <button type="submit" className="finance-icon-button" title="Mikro'da ara" aria-label="Mikro'da ara" disabled={loading || term.trim().length < 2}><Search size={17} /></button>
    </form>
    {loading && <p role="status">Cari kartları aranıyor.</p>}
    {error && <p className="finance-alert" role="alert">{error}</p>}
    {searched && rows.length === 0 && <p role="status">Eşleşen cari bulunamadı.</p>}
    {rows.length > 0 && <div className="finance-search-results">{rows.map((row) => <button type="button" className="finance-button" key={row.code}
      onClick={() => select(row.code)}><span>{row.code} · {row.name} · {row.currency}</span></button>)}</div>}
  </section>;
}
